import { Stack, Typography } from '@mui/material';
import { useTranslation } from '../../../services/translation/hooks/useTranslation';
import { FeatureFlagsLauncher } from './components/FeatureFlagsLauncher';
import { FeatureFlagsMenu } from './components/FeatureFlagsMenu';

export const FeatureFlagSettings = () => {
  const { t } = useTranslation();

  return (
    <Stack direction='column'>
      <Typography variant='body2' component='p' sx={{ marginBottom: 4 }}>
        {t(
          'Note: The checkboxes on the right are read-only, and show the feature flag value as managed by {{launchDarkly}}. ' +
            'Some feature flags can be temporarily disabled on your local view using the toggle switches. ' +
            'They will be reset to their original value after refreshing the page. ' +
            'You can launch the feature flags management page using the link below.',
          {
            launchDarkly: 'LaunchDarkly',
          }
        )}
      </Typography>
      <FeatureFlagsLauncher />
      <FeatureFlagsMenu />
    </Stack>
  );
};
